module.exports = `<!DOCTYPE html>
<html>
<title>Trojan Energy Limited - Document Portal</title>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css">
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Raleway">
<script src="https://kit.fontawesome.com/0ee23d3d9a.js" crossorigin="anonymous"></script>
<style>
html,body,h1,h2,h3,h4,h5 {font-family: "Raleway", sans-serif}

  .container {
    display: table;
    }

  .row  {
    display: table-row;
    }

  .left, .right, .middle {
    display: table-cell;
    padding: 10px;
    }
</style>
<body class="w3-light-grey">

<!-- Top container -->
<div class="w3-bar w3-top w3-black w3-large" style="z-index:4">
  <button class="w3-bar-item w3-button w3-hide-large w3-hover-none w3-hover-text-light-grey" onclick="w3_open();"><i class="fa fa-bars"></i>  Menu</button>
  <span class="w3-bar-item w3-left"><img src="images/Trojan_Logo.png" alt="Trojan Energy Limited" height="50px"></img></span>
  <h2>Guidelines</h2>
</div>

<!-- Sidebar/menu -->
<nav class="w3-sidebar w3-collapse w3-white w3-animate-left" style="z-index:3;width:300px;" id="mySidebar"><br>
  <div class="w3-container w3-row">
    <br />
    <div class="w3-col s4">
      <img src="images/avatars/avatar2.png" class="w3-circle w3-margin-right" style="width:46px">
    </div>
    <div class="w3-col s8 w3-bar">
      <span>Welcome, <strong>Marsha</strong></span><br>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-envelope"></i></a>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-user"></i></a>
      <a href="#" class="w3-bar-item w3-button"><i class="fa fa-cog"></i></a>
    </div>
  </div>
  <hr>
  <div class="w3-container">
    <h5>Actions</h5>
  </div>
  <div class="w3-container">
    Search By
    <div class="w3-bar-block">
        <a href="#" class="w3-bar-item w3-button w3-padding-16 w3-hide-large w3-dark-grey w3-hover-black" onclick="w3_close()" title="close menu"><i class="fa fa-remove fa-fw"></i>  Close Menu</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  SDRL Code</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  System Hierarchy</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Model Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Serial Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Discipline</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Location</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Author</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Client</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Project</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Workscope</a><br><br>
    </div>
  </div>
  <div class="w3-container">
    Document Management
    <div class="w3-bar-block">
        <a href="#" class="w3-bar-item w3-button w3-padding-16 w3-hide-large w3-dark-grey w3-hover-black" onclick="w3_close()" title="close menu"><i class="fa fa-remove fa-fw"></i>  Close Menu</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Create Document Number</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Upload Document</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Workflow Document</a>
        <a href="#" class="w3-bar-item w3-button w3-padding"><i class="fa fa-toggle-right fa-fw"></i>  Create Transmittal</a>
    </div>
  </div>
</nav>

<!-- Overlay effect when opening sidebar on small screens -->
<div class="w3-overlay w3-hide-large w3-animate-opacity" onclick="w3_close()" style="cursor:pointer" title="close side menu" id="myOverlay"></div>

<!-- !PAGE CONTENT! -->
<div class="w3-main" style="margin-left:300px;margin-top:43px;">

  <!-- Header -->
  <header class="w3-container" style="padding-top:22px">
    <a href="doc_controller" style="text-decoration:none;"><h5><b><i class="fa fa-toggle-left"></i> Doc Controller</b></h5></a>
  </header>

  <div class="w3-row-padding w3-margin-bottom">
    <div>
      <div class="w3-container w3-dark-gray w3-padding-16">
        <div class="w3-left"><i class="fa fa-scale-balanced w3-xxxlarge"></i></div>
        <div class="w3-right">
          <h3>16</h3>
        </div>
        <div class="w3-clear"></div>
        <h4>Guidelines</h4>
      </div>
    </div>
  </div>

  <div class="w3-third" style="padding:20px">
    <div class="w3-row-padding" style="margin:0 -16px">
      <div>
        <h5><b> None published at this time.</b></h5>
      </div>



    </div>
  </div>
  <iframe name="previewer" src="" class="w3-twothird" height="100%" frameBorder="0"></iframe>
  <hr />
  <hr />
  <br>
  <!--
  <div class="w3-container w3-dark-grey w3-padding-32">
    <div class="w3-row">
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-red">To Action</h5>
        <p>Rejected Workflows</p>
        <p>Review Overdue</p>
        <p></p>
      </div>
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-orange">In-Progress</h5>
        <p>Unreleased Documents</p>
        <p>Workflow Comments</p>
        <p>Review Ongoing</p>
      </div>
      <div class="w3-container w3-third">
        <h5 class="w3-bottombar w3-border-green">Completed</h5>
        <p>Document Releases</p>
        <p>Transmittals</p>
        <p>Review Cycles /  Approvals</p>
      </div>
    </div>
  </div> -->

  <!-- Footer -->
  <footer class="w3-container w3-padding-16 w3-light-grey">
    <h4>TROJAN ENERGY LIMITED, 2022</h4>
    <p>Powered by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">w3.css</a></p>
  </footer>

  <!-- End page content -->
</div>

<script>
// Get the Sidebar
var mySidebar = document.getElementById("mySidebar");

// Get the DIV with overlay effect
var overlayBg = document.getElementById("myOverlay");

// Toggle between showing and hiding the sidebar, and add overlay effect
function w3_open() {
  if (mySidebar.style.display === 'block') {
    mySidebar.style.display = 'none';
    overlayBg.style.display = "none";
  } else {
    mySidebar.style.display = 'block';
    overlayBg.style.display = "block";
  }
}

// Close the sidebar with the close button
function w3_close() {
  mySidebar.style.display = "none";
  overlayBg.style.display = "none";
}

// Change the map focus point
function changeMapFocus() {
    location = Math.floor(Math.random() * 10);
    var mapObject = document.getElementById("mapObject");

    switch(location) {
        case 0:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 1:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 2:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 3:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 4:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 5:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 6:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 7:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 8:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        case 9:
            data="https://www.openstreetmap.org/export/embed.html?bbox=-0.22571861743927005%2C51.53026587851656%2C-0.21676003932952884%2C51.53313245216958&amp;layer=mapnik";
            break;
        default:
            data="https://www.openstreetmap.org/#map=17/56.96566/-2.21837";
            break;
    }
}

</script>

</body>
</html>`;
